import "core-js/modules/es6.array.map";
import a from "react";
import { Ccpa as g, CanadaFlag as t, UkFlag as i, UsFlag as h } from "@hagerty/icons";

var p = function p(_ref) {
  var o = _ref.subdomain;
  return a.createElement(a.Fragment, null, a.createElement("a", {
    className: "hg-global-footer__flag",
    href: "https://".concat(o, ".hagerty.com"),
    "aria-label": "Link to Hagerty US"
  }, a.createElement(h, null)), a.createElement("a", {
    className: "hg-global-footer__flag",
    href: "https://".concat(o, ".hagerty.ca"),
    "aria-label": "Link to Hagerty Canada"
  }, a.createElement(t, null)), a.createElement("a", {
    className: "hg-global-footer__flag",
    href: "https://www.hagerty.co.uk",
    "aria-label": "Link to Hagerty UK"
  }, a.createElement(i, null)));
},
    b = function b(_ref2) {
  var _ref2$subdomain = _ref2.subdomain,
      o = _ref2$subdomain === void 0 ? "www" : _ref2$subdomain,
      _ref2$showCCPA = _ref2.showCCPA,
      s = _ref2$showCCPA === void 0 ? !1 : _ref2$showCCPA,
      r = _ref2.legalLinks;
  return a.createElement("div", {
    className: "hg-global-footer__corporate-footer"
  }, a.createElement("nav", {
    className: "hg-global-footer__legal-links"
  }, a.createElement("ul", null, s && a.createElement("li", null, a.createElement("a", {
    href: "https://submit-irm.trustarc.com/services/validation/77672a09-1fe3-41a9-b911-46cc3603a305"
  }, a.createElement(g, null), "Your privacy choices")), r == null ? void 0 : r.map(function (l, e) {
    return a.createElement("li", {
      key: e,
      id: l.id
    }, a.createElement("a", {
      href: l.url
    }, l.label));
  }))), a.createElement("div", {
    className: "hg-global-footer__copyright-wrapper"
  }, a.createElement("div", {
    className: "hg-global-footer__flags"
  }, a.createElement(p, {
    subdomain: o
  })), a.createElement("div", {
    className: "hg-global-footer__copyright-label"
  }, "The Hagerty Group, LLC \xA9 1996 \u2013 ", new Date().getFullYear())));
};

export { b as CorporateFooter };